import { Component, ElementRef, OnInit, ViewChild, Input, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../environments/environment';
import { Helpers } from '../helpers';
import { TranslateConfigService } from '../theme/home/translateConfig.service';
import { appService } from '../_services/app.service';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../auth/_services/encrypt-decrypt.pipe';
import { CommonService } from '../_services/common.service';
import { RequestOptions, Headers, Http } from "@angular/http";

const LNG_KEY = "SELECTED_LANGUAGE";
declare var moment: any;
declare var $: any;

@Component({
  selector: 'app-sending-mail',
  templateUrl: './sending-mail.component.html',
  styleUrls: ['./sending-mail.component.scss']
})
export class SendingMailComponent implements OnInit {
  OnClickSendMail() {
    throw new Error('Method not implemented.');
  }

  static that: SendingMailComponent;
  @Input() invoiceData: any;
  selectedLang: string;
  @Input() sendData: any;
  UserId: any;
  fromEmail: any = '';
  fromEmailId: any = null;
  EmailSubject: string = '';
  Recipient: string = '';
  ccEmail: any = '';
  Message: string = '';
  PrintData: any = [];
  PrintDataModal: any = {};
  RoundOfAmount: any = 0;
  InvoiceId: string = '';
  SelectedComapnyName: any;
  SelectedCompanyAdd: any;
  SelectedCompanyCIN: any;
  SelectedCompantGSTIN: any;
  SelectedCompanyGSTCode: any;
  SelectedCompanyLogo: any;
  SelectedCompanyPAN: any;
  Type: string = '';
  E_Invoice_On_OffFlag = false;
  InvoiceDate: any;
  DueDate: any;
  InvoiceNo: any;
  //add maaria on 16-10-2023
  OrderNo: any;
  transactionNo: any;
  //end
  InvoiceAmount: any;
  isOutstandingStatement: any = false;
  //added by vithujan 31-08-2023
 @Input() isQuotation: boolean = false;

  //add maaria 
  responseList: any = [];
  mailHistoryList: any = [];
  mailObj: any = {};
  toList: any = [];
  isMailHistory: any = false;
  emailLogobj: any = {};
  emailAttachmentType: any = '';
  //end

  //Document
  // isTransporter: boolean = false;
  // isCustomer: boolean = false;
  // FileStructure: any = [];
  // ParentId: any = null;
  // DocumentType: any = "Documents";
  // TransactionList: any = [];
  // datatable: any;
  // DocumentTransaction: any = null;
  // IsSearchHidden: any = false;
  // selectFile: any;
  // modalReference: any;
  // InvoiceDetails: any;
  // InvoiceIds: any;
  // SelectedAttachements: any = [];

  @ViewChild('PrintSummary1') PrintSummary1: ElementRef;
  @Input() IsEIRMail: boolean = false;
  @Input() EIRData: any;
  @Input() BookingId: any;
  constructor(
    private service: TranslateConfigService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private _appService: appService,
    private toastr: ToastrService
  ) {
    SendingMailComponent.that = this;
    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    document.getElementById("Message").innerHTML = this.Message;
    this.UserId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.Type = 'Summary';
    this.GetLoginCompanyData();
    //add by maaria on 16-10-2023
    //this.GetMailHistory();
    //end
    //added by rahul
    this.GetSalesInvoicePrintFormats();
    //end
  }


  GetLoginCompanyData() {
    this.SelectedComapnyName = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedComapnyName;
    this.SelectedCompanyAdd = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompanyAdd;
    this.SelectedCompanyCIN = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompanyCIN;
    this.SelectedCompantGSTIN = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompantGSTIN;
    this.SelectedCompanyGSTCode = JSON.parse(localStorage.getItem("ChnageCompnayId")).GSTCode;
    this.SelectedCompanyLogo = JSON.parse(localStorage.getItem("ChnageCompnayId")).CompanyLogoPath;
    this.SelectedCompanyLogo = JSON.parse(localStorage.getItem("ChnageCompnayId")).CompanyLogoPath;
    this.SelectedCompanyPAN = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompanyPAN;
    this.E_Invoice_On_OffFlag = JSON.parse(localStorage.getItem("E_Invoice_On_OffFlag"));

    $(".SalesLogoImg").attr(
      "src",
      environment.apiUrl + this.SelectedCompanyLogo
    );
  }

  validateEmail(field) {
    var regex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b/i;
    return (regex.test(field)) ? true : false;
  }

  validateMultipleEmailsCommaSeparated(value) {
    var result = value.split(",");
    for (var i = 0; i < result.length; i++)
      if (!this.validateEmail(result[i]))
        return false;
    return true;
  }

  GetPrintDataValue(Type) {
    this.Type = Type;
    switch (Type) {
      case 'Summary':
        this.emailAttachmentType = "Print Invoice";
        break;
      case 'Summary_FixedKM':
        this.emailAttachmentType = "Print Invoice (FixedKM)";
        break;
      case 'Detail':
        this.emailAttachmentType = "Print Invoice Detail";
        break;
      case 'Detail1':
        this.emailAttachmentType = "Print Invoice - PDF";
        break;
      case 'PDF_EInvoice':
        this.emailAttachmentType = "Print Invoice - PDF(E-Invoice)";
        break;
      case 'Detail1OnLatterPad':
        this.emailAttachmentType = "Print Invoice - Letterhead";
        break;
      case 'OnLatterPad_EInvoice':
        this.emailAttachmentType = "Print Invoice - Letterhead(E-Invoice)";
        break;
      case 'Detail_KM_MT':
        this.emailAttachmentType = "Print Invoice Detail(KM/MT)";
        break;
      case 'PrintInvoiceInfinity':
        this.emailAttachmentType = "Print Invoice Landscape";
        break;
      default:
        this.emailAttachmentType = "Print Invoice";
    }
  }

  ngAfterViewInit() {
    // $("#DocumentFrom").val("Document");
    // this.DocumentType = "SalesInvoice";
    // this.DocumentTransaction = this.InvoiceId;
    // this.IsSearchHidden = true;
    // this.CreateDefaultFolders();
    // this.GetDocumentsList();
    this.GetSelect2Data();
  }

  GetSelect2Data() {
    $("#se2_fromEmail").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/EmailConfiguration/get_fromEmailSelectList",
        headers: {
          "Authorization": SendingMailComponent.that._appService.getAuthToken(),
        },
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            Id: SendingMailComponent.that.UserId,
            param1: params.term,
          };
        },
        processResults: function (data) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Search for Email",
    });
    $("#se2_fromEmail").on("select2:select", function (e) {
      var data = e.params.data;
      SendingMailComponent.that.fromEmailId = data.id;
      SendingMailComponent.that.fromEmail = data.emailId;
    });

    $("#se2_ToEmail").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/EmailConfiguration/get_defaultText",
        headers: {
          "Authorization": SendingMailComponent.that._appService.getAuthToken(),
        },
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            Id: SendingMailComponent.that.UserId,
            param1: params.term,
          };
        },
        processResults: function (data) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Search To Email",
    });
    $("#se2_ToEmail").on("select2:select", function (e) {
      var data = e.params.data;
      if ($("#se2_ToEmail").val() != "") {
        SendingMailComponent.that.Recipient = $("#se2_ToEmail").val().join(",");
      }
    });

    $("#se2_ccEmail").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/EmailConfiguration/get_defaultText",
        headers: {
          "Authorization": SendingMailComponent.that._appService.getAuthToken(),
        },
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            Id: SendingMailComponent.that.UserId,
            param1: params.term,
          };
        },
        processResults: function (data) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Search CC Email",
    });
    $("#se2_ccEmail").on("select2:select", function (e) {
      var data = e.params.data;
      if ($("#se2_ccEmail").val() != "") {
        SendingMailComponent.that.ccEmail = $("#se2_ccEmail").val().join(",");
      }
    });
  }

  clearSelectData() {
    if ($("#se2_fromEmail").select2()) {
      $("#se2_fromEmail").val("");
      $("#se2_fromEmail").select2("destroy");
    }
    if ($("#se2_ToEmail").select2()) {
      $("#se2_ToEmail").val("");
      $("#se2_ToEmail").select2("destroy");
    }

    if ($("#se2_ccEmail").select2()) {
      $("#se2_ccEmail").val("");
      $("#se2_ccEmail").select2("destroy");
    }
    this.GetSelect2Data();
    let Optionsse2_ToEmail = '';
    let Optionsse2_CCEmail = '';
    // this.ccEmail = '';
    Optionsse2_ToEmail += '<option value="' + this.Recipient + '">' + this.Recipient + '</option>';
    $("#se2_ToEmail").html(Optionsse2_ToEmail);
    $("#se2_ToEmail").val(this.Recipient).change();

    // Added by priya - 12/03/2026 - cn(PRIYA-MAR26-002)
    Optionsse2_CCEmail += '<option value="' + this.ccEmail + '">' + this.ccEmail + '</option>';
    $("#se2_ccEmail").html(Optionsse2_CCEmail);
    $("#se2_ccEmail").val(this.ccEmail).change();
    // End by priya

    $("#in_isOutstandingStatement").prop("checked", false);
    this.isOutstandingStatement = false;
  }

  getLoginUserEmailOrDefaultEmail() {
    this._appService.GetById("EmailConfiguration", "get_fromEmailUserWise", this.UserId).subscribe((response) => {
      this.fromEmailId = response[0].Id;
      this.fromEmail = response[0].emailId;
      var Optionsse2_fromEmail = "";
      Optionsse2_fromEmail += '<option value="' + response[0].Id + '">' + response[0].emailId + "</option>";
      $("#se2_fromEmail").html(Optionsse2_fromEmail);
      $("#se2_fromEmail").val(response[0].Id).change();
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  getEmailSelectedVAl() {
    SendingMailComponent.that.Recipient = $("#se2_ToEmail").val().join(",");
    SendingMailComponent.that.ccEmail = $("#se2_ccEmail").val().join(",");
  }

  Change_isOutstandingStatement() {
    if ($("#in_isOutstandingStatement").is(":checked") == true) {
      this.isOutstandingStatement = true;
    } else {
      this.isOutstandingStatement = false;
    }
  }

  //add maaria on 16-10-2023
  GetMailHistory() {
    this.mailHistoryList = [];
    this.isMailHistory = false;
    if (this.isQuotation == true) {
      this.emailLogobj.Transaction = this.OrderNo;
    }
    else {
      this.emailLogobj.Transaction = this.InvoiceNo;
    }

    this._appService.Post("Sales", "GetMailHistory", this.emailLogobj).subscribe(
      (response) => {
        console.log(response);
        if (response.length > 0) {
          response.forEach(item => {
            this.mailObj = [];

            if (item.To.includes(',')) {
              this.toList = [];
              this.toList = item.To.split(',');

              this.toList.forEach(ele => {
                this.mailObj = [];
                this.mailObj.Transaction = item.Transaction;
                this.mailObj.From = item.From;
                this.mailObj.Date = item.CreatedDate;
                this.mailObj.To = ele;
                this.mailHistoryList.push(this.mailObj);
              });
            }
            else {
              this.mailObj.Transaction = item.Transaction;
              this.mailObj.From = item.From;
              this.mailObj.Date = item.CreatedDate;
              this.mailObj.To = item.To;
              this.mailHistoryList.push(this.mailObj);
            }

          });
          this.isMailHistory = true;
        }
        else {
          //this.showPartB = false;
        }
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );

  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['invoiceData'] && this.invoiceData) {
      this.prefillData();
    }
  }

  prefillData() {
    this.InvoiceNo = this.invoiceData.InvoiceNumber;
    this.OrderNo = this.invoiceData.OrderNo;
    this.InvoiceDate = this.invoiceData.InvoiceDate;
    this.DueDate = this.invoiceData.InvoiceDueDate;
    this.InvoiceAmount = this.invoiceData.TotalAmount;

    this.EmailSubject = this.translate.instant('SALESCOMP.Invoice') + ' ' + this.InvoiceNo;
    this.Message = this.translate.instant('SALESCOMP.Dear') + ' ' +
      this.invoiceData.CustomerName + '\n\n' +
      this.translate.instant('SALESCOMP.EmailBodyMessage');

    const BillToPartyEmail = this.invoiceData.BillToPartyEmail || '';
    this.Recipient = BillToPartyEmail
      ? this.invoiceData.Email + ',' + BillToPartyEmail
      : this.invoiceData.Email;

    this.ccEmail = this.invoiceData.CCEmail; // Added by priya - 12/03/2026 - cn(PRIYA-MAR26-002)

    this.clearSelectData();
    this.GetMailHistory();
    this.getLoginUserEmailOrDefaultEmail();
  }

  
  //end



  // CreateDefaultFolders() {
  //   this._appService.Get("Document", "CreateDefaultFolders").subscribe(
  //     (response) => { },
  //     (err) => {
  //       this.toastr.error(err._body.replace(/"/g, ""), "error");
  //     }
  //   );
  // }

  // DownloadFolder(Id) {
  //   this._appService.GetById("Document", "DownloadFolder", Id).subscribe(
  //     (response) => {
  //       if (response != "" && response != undefined && response != null) {
  //         var path =
  //           environment.apiUrl + "/DocumentLibrary/Downloads/" + response;
  //         window.open(path, "");
  //       }
  //     },
  //     (err) => {
  //       this.toastr.error("Error occured while downaloading folder !", "error");
  //     }
  //   );
  // }

  // GoBackFolder(ParentId, index) {
  //   this.FileStructure.splice(index);
  //   this.datatable.search(ParentId, "ParentId");
  //   this.ParentId = ParentId;
  // }

  // GoToChild(data) {
  //   var flagExist = false;
  //   this.FileStructure.forEach((element) => {
  //     if (data.Id == element.ParentId) flagExist = true;
  //   });
  //   if (!flagExist) {
  //     var obj: any = {};
  //     obj.ParentId = data.Id;
  //     obj.FileName = data.FileName;
  //     this.FileStructure.push(obj);
  //     this.ParentId = data.Id;
  //   }
  // }

  // UploadAttachment(event) {
  //   this.selectFile = event.target.files[0];
  //   if (
  //     this.selectFile == undefined ||
  //     this.selectFile == "" ||
  //     this.selectFile == null
  //   ) {
  //     this.toastr.error("Please select file to upload", "error");
  //     $("#UploadDocFile").val("");
  //     return false;
  //   }

  //   //--------------File True Type Validation ---------- added by vithujan 22-09-2022
  //   var fileReader = new FileReader();
  //   var isValidFileType = true;
  //   fileReader.onloadend = function (e: any) {
  //     var arr = (new Uint8Array(e.target.result)).subarray(0, 4);
  //     var header = "";

  //     for (var i = 0; i < arr.length; i++) {
  //       header += arr[i].toString(16);
  //     }

  //     //89504E47 (PNG) || 25504446 (PDF) || FFD8FFE0(JPEG) || FFD8FFE1 (JPG) || D0CF11E0 (XLS) || 504B34 (XLSX) || 43686172 (CSV)
  //     if (header.toUpperCase() != '89504E47' && header.toUpperCase() != 'FFD8FFE0' && header.toUpperCase() != 'FFD8FFE1' && header.toUpperCase() != '25504446') {
  //       SendingMailComponent.that.toastr.error(SendingMailComponent.that.translate.instant("SETTING.DocOnly"), 'Error');
  //       $("#UploadDocFile").val("");
  //       isValidFileType = false;
  //       return false;
  //     }
  //   };
  //   fileReader.readAsArrayBuffer(this.selectFile);
  //   //----------------------------------------------

  //   setTimeout(() => {
  //     if (isValidFileType) {
  //       //--------------Filename Validation ---------- added by vithujan 23-09-2022
  //       var format = /^[a-zA-Z0-9]*\.[a-zA-Z0-9]*$/;
  //       if (!format.test(this.selectFile.name)) {
  //         this.toastr.error(this.translate.instant("SETTING.InvalidFile"), 'Error');
  //         $("#UploadDocFile").val("");
  //         return false;
  //       }

  //       //--------------File Type Validation ---------- added by vithujan 15-09-2022
  //       var meme_type = this.selectFile.type;
  //       if ((meme_type.toLowerCase() != "image/jpeg") && (meme_type.toLowerCase() != "image/png") && (meme_type.toLowerCase() != "application/pdf")) {
  //         this.toastr.error(this.translate.instant("SETTING.DocOnly"), 'Error');
  //         $("#UploadDocFile").val("");
  //         return false;
  //       }
  //       //end

  //       //--------------Size Validation----------------
  //       var bytesize = this.selectFile.size;
  //       var kbsize: any = 0;
  //       kbsize = (bytesize / 1000).toFixed(2);
  //       let IsFileSizeExceed = false;
  //       if (kbsize > 1024) {
  //         if (kbsize / 1024 > environment.maxFileSize) IsFileSizeExceed = true;
  //         else IsFileSizeExceed = false;
  //       }
  //       if (IsFileSizeExceed) {
  //         this.toastr.error(this.translate.instant("SETTING.FileSize"), 'Error');
  //         $("#UploadDocFile").val("");
  //         return false;
  //       }
  //       //----------------------------------------------

  //       var fd = new FormData();
  //       if (fd.has("file")) {
  //         fd.set("file", this.selectFile);
  //       } else {
  //         fd.append("file", this.selectFile);
  //       }

  //       //added by vithujan 31-01-2023
  //       SendingMailComponent.that.DocumentType = "SalesInvoice";
  //       //end

  //       var headers = new Headers();
  //       let user_access_token = this.decryptpipe.transform(JSON.parse(this.cookieService.get("user_access_token")));
  //       const token: string = "Bearer " + user_access_token;
  //       headers.append("Authorization", token);
  //       let options = new RequestOptions({ headers: headers });
  //       const apiUrl =
  //         environment.apiUrl +
  //         "/api/Document/UploadAttachment?ReferenceId=" +
  //         this.InvoiceId +
  //         "&TransectionType=" +
  //         this.DocumentType +
  //         "&ParentId=" +
  //         this.ParentId;
  //       const req1 = this.anghttp.post(apiUrl, fd, options).subscribe(
  //         (response) => {
  //           SendingMailComponent.that.datatable.reload();
  //           const updatesucess = this.translate.instant("ALERTMESSAGES.updatesucess");
  //           this.toastr.success(updatesucess, "Success");
  //           $("#UploadDocFile").val("");
  //         },
  //         (err) => {
  //           $("#UploadDocFile").val("");
  //           this.toastr.error("Error occured while Uploading...", "error");
  //         }
  //       );
  //     }
  //   }, 2000);

  // }

  // GetDocumentsList() {
  //   this.datatable = (<any>$("#m_datatable_Document")).mDatatable({
  //     data: {
  //       type: "remote",
  //       source: {
  //         read: {
  //           method: "POST",
  //           url: environment.apiUrl + "api/Document/DocumentsGetListMailAttachment",
  //           params: {
  //             // custom parameters
  //             ReferenceId:
  //               SendingMailComponent.that.DocumentTransaction,
  //             //add kevin 27/10/2020
  //             isTransporter: SendingMailComponent.that.isTransporter,
  //             isCustomer: SendingMailComponent.that.isCustomer,
  //             userId: SendingMailComponent.that.UserId,
  //             //end
  //           },
  //         },
  //       },
  //       pageSize: 10,
  //       serverPaging: !0,
  //       serverFiltering: !0,
  //     },
  //     layout: {
  //       class: "m--margin-top-5",
  //       scroll: false,
  //       footer: !1,
  //       smoothScroll: {
  //         scrollbarShown: true,
  //       },
  //     },
  //     sortable: !0,
  //     pagination: !0,
  //     toolbar: {
  //       items: {
  //         pagination: {
  //           pageSizeSelect: [10, 20, 30, 50, 100],
  //         },
  //       },
  //     },
  //     search: {
  //       onChange: true,
  //       input: $("#FileFolderSearch"),
  //       delay: 400,
  //     },
  //     rows: {
  //       afterTemplate: function (row, data, index) {
  //         //Start: Download Button
  //         $(row)
  //           .find(".btnDownload")
  //           .click(function () {
  //             var path = $(this).attr("Id");
  //             var FileName = $(this).attr("FileName");
  //             var path1 =
  //               environment.apiUrl + path + FileName + "." + data.FileExtension;
  //             window.open(path1, "");
  //           });
  //         $(row)
  //           .find(".btnFolderDownload")
  //           .click(function () {
  //             SendingMailComponent.that.DownloadFolder(data.Id);
  //           }); //Ends;

  //         //Start: Delete Button
  //         $(row)
  //           .find(".btnDelete")
  //           .click(function () {
  //             var Id = $(this).attr("Id");
  //             swal({
  //               title: "Are you sure?",
  //               text: "You won't be able to revert this!",
  //               type: "warning",
  //               showCancelButton: !0,
  //               confirmButtonText: "Yes, delete it!",
  //             }).then(function (e) {
  //               if (e.value == true) {
  //                 SendingMailComponent.that._appService
  //                   .Delete("Document", "DeleteAttachment", Id)
  //                   .subscribe(
  //                     (response) => {
  //                       SendingMailComponent.that.datatable.reload();
  //                     },
  //                     (err) => {
  //                       SendingMailComponent.that.toastr.error(
  //                         "An error occured while deleting data !",
  //                         "error"
  //                       );
  //                     }
  //                   );
  //               }
  //             }); //Ends;
  //           });
  //         $(row)
  //           .find(".btnGoInsideFolder")
  //           .click(function () {
  //             var Id = $(this).attr("Id");
  //             SendingMailComponent.that.GoToChild(data);
  //             SendingMailComponent.that.datatable.search(
  //               Id,
  //               "ParentId"
  //             );
  //           });
  //       },
  //     },
  //     columns: [
  //       {
  //         field: "Id",
  //         title: "#",
  //         sortable: !1,
  //         width: 20,
  //         selector: {
  //           class:
  //             "m-checkbox m-datatable--on-check m-checkbox--solid m-checkbox--brand BookingIdCheckbox",
  //         },
  //         template: function (t) {
  //           let value = t;
  //           return value;
  //         },
  //       },
  //       {
  //         field: "FileName",
  //         title: this.selectedLang == 'sp' ? "Nombre de archivo" : "File Name",
  //         filterable: !1,
  //         width: 500,
  //         template: function (t) {
  //           var btn = "";
  //           if (t.FileExtension != "Folder") {
  //             var FileName = t.FileName.split(/_(.+)/)[1];
  //             if (FileName == undefined) FileName = t.FileName;
  //             if (t.FileExtension == "apk") {
  //               // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
  //               btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
  //                 t.Path +
  //                 t.FileName +
  //                 "." +
  //                 t.FileExtension
  //                 } "  title="View File"> 
  //                               <img src="./assets/app/media/img/logos/FileImages/APK.png" style="width: 20px;"></img> ${FileName}.${t.FileExtension
  //                 }
  //                               </a>`;
  //             } else if (t.FileExtension == "csv") {
  //               // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
  //               btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
  //                 t.Path +
  //                 t.FileName +
  //                 "." +
  //                 t.FileExtension
  //                 } "  title="View File"> 
  //                               <img src="./assets/app/media/img/logos/FileImages/CSV.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
  //                 }
  //                               </a>`;
  //             } else if (
  //               t.FileExtension == "doc" ||
  //               t.FileExtension == "docx"
  //             ) {
  //               // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
  //               btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
  //                 t.Path +
  //                 t.FileName +
  //                 "." +
  //                 t.FileExtension
  //                 } "  title="View File"> 
  //                               <img src="./assets/app/media/img/logos/FileImages/DOC.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
  //                 }
  //                               </a>`;
  //             } else if (t.FileExtension == "exe") {
  //               // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
  //               btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
  //                 t.Path +
  //                 t.FileName +
  //                 "." +
  //                 t.FileExtension
  //                 } "  title="View File"> 
  //                               <img src="./assets/app/media/img/logos/FileImages/EXE.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
  //                 }
  //                               </a>`;
  //             } else if (
  //               t.FileExtension == "jpg" ||
  //               t.FileExtension == "jpeg"
  //             ) {
  //               // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
  //               btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
  //                 t.Path +
  //                 t.FileName +
  //                 "." +
  //                 t.FileExtension
  //                 } "  title="View File"> 
  //                               <img src="./assets/app/media/img/logos/FileImages/JPEG.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
  //                 }
  //                               </a>`;
  //             } else if (t.FileExtension == "pdf") {
  //               // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
  //               btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
  //                 t.Path +
  //                 t.FileName +
  //                 "." +
  //                 t.FileExtension
  //                 } "  title="View File"> 
  //                               <img src="./assets/app/media/img/logos/FileImages/PDF.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
  //                 }
  //                               </a>`;
  //             } else if (t.FileExtension == "png") {
  //               // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
  //               btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
  //                 t.Path +
  //                 t.FileName +
  //                 "." +
  //                 t.FileExtension
  //                 } "  title="View File"> 
  //                               <img src="./assets/app/media/img/logos/FileImages/PNG.png" class="ImgFileType"></img>  ${FileName}.${t.FileExtension
  //                 }
  //                               </a>`;
  //             } else if (
  //               t.FileExtension == "ppt" ||
  //               t.FileExtension == "pptx"
  //             ) {
  //               // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
  //               btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
  //                 t.Path +
  //                 t.FileName +
  //                 "." +
  //                 t.FileExtension
  //                 } "  title="View File"> 
  //                               <img src="./assets/app/media/img/logos/FileImages/PPT.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
  //                 }
  //                               </a>`;
  //             } else if (t.FileExtension == "psd") {
  //               // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
  //               btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
  //                 t.Path +
  //                 t.FileName +
  //                 "." +
  //                 t.FileExtension
  //                 } "  title="View File"> 
  //                               <img src="./assets/app/media/img/logos/FileImages/PSD.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
  //                 }
  //                               </a>`;
  //             } else if (t.FileExtension == "sql") {
  //               // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
  //               btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
  //                 t.Path +
  //                 t.FileName +
  //                 "." +
  //                 t.FileExtension
  //                 } "  title="View File"> 
  //                               <img src="./assets/app/media/img/logos/FileImages/SQL.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
  //                 }
  //                               </a>`;
  //             } else if (t.FileExtension == "txt") {
  //               // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
  //               btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
  //                 t.Path +
  //                 t.FileName +
  //                 "." +
  //                 t.FileExtension
  //                 } "  title="View File"> 
  //                               <img src="./assets/app/media/img/logos/FileImages/TXT.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
  //                 }
  //                               </a>`;
  //             } else if (
  //               t.FileExtension == "xls" ||
  //               t.FileExtension == "xlsx"
  //             ) {
  //               // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
  //               btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
  //                 t.Path +
  //                 t.FileName +
  //                 "." +
  //                 t.FileExtension
  //                 } "  title="View File"> 
  //                               <img src="./assets/app/media/img/logos/FileImages/XLS.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
  //                 }
  //                               </a>`;
  //             } else {
  //               // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
  //               btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
  //                 t.Path +
  //                 t.FileName +
  //                 "." +
  //                 t.FileExtension
  //                 } "  title="View File"> 
  //                               <img src="./assets/app/media/img/logos/FileImages/Default.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
  //                 }
  //                               </a>`;
  //             }
  //           } else {
  //             if (t.FileExtension == "Folder") {
  //               // btn = `<span  Id="${t.Id}"   class="btnGoInsideFolder  btn" style="color: #3b67fb;padding: 0px"><img src="./assets/app/media/img/logos/FileImages/folder.png" style="height: 30px;width: 35px;"></img>  ${t.FileName}</span>`
  //               btn = `<div style="display:flex;"  Id="${t.Id}"   class="btnGoInsideFolder  btn" style="color: #3b67fb;padding: 0px"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30px" height="30px" viewBox="0 0 24 24" version="1.1"  class="kt-svg-icon">
  //                               <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
  //                                   <rect x="0" y="0" width="24" height="24"/>
  //                                   <path d="M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z" fill="#000000" opacity="0.3"/>
  //                               </g>
  //                           </svg><span style="transform:translateY(10px) ; margin-left:10px">${t.FileName}</span></div>`;
  //             }
  //           }
  //           return btn;
  //         },
  //       },
  //       {
  //         field: "DocumentType",
  //         title: this.selectedLang == 'sp' ? "Tipo de documento" : "Document Type",
  //         filterable: !1,
  //         width: 130,
  //       },
  //       {
  //         field: "ModifiedDate",
  //         title: this.selectedLang == 'sp' ? "Fecha de modificación" : "Modified Date",
  //         filterable: !1,
  //         width: 100,
  //       },
  //       {
  //         field: "UploadedBy",
  //         title: this.selectedLang == 'sp' ? "Subido por" : "Uploaded By",
  //         filterable: !1,
  //         width: 120,
  //       },
  //       {
  //         field: "Actions",
  //         width: 80,
  //         title: this.selectedLang == 'sp' ? "Acciones" : "Actions",
  //         sortable: !1,
  //         overflow: "visible",
  //         template: function (t) {
  //           var btn = "";
  //           const bookLiveTrack = SendingMailComponent.that.translate.instant("BYCUSTOMER.bookLiveTrack");
  //           const tripDownloadOrder = SendingMailComponent.that.translate.instant("BYCUSTOMER.tripDownloadOrder");
  //           const tripViewOrderDetail = SendingMailComponent.that.translate.instant("BYCUSTOMER.tripViewOrderDetail");
  //           const tripViewRouteAndLoadPlan = SendingMailComponent.that.translate.instant("BYCUSTOMER.tripViewRouteAndLoadPlan");
  //           btn += `<span style="overflow: visible; width: 110px;">
  //                       <a href="#" class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" data-toggle="dropdown">
  //                       <i class="la la-ellipsis-h"></i>
  //                       </a>
  //                       <div class="dropdown-menu dropdown-menu-left">`;
  //           if (
  //             SendingMailComponent.that.commonService.CheckHasRight(
  //               "EDIT",
  //               "ATTACHMENT_DETAILS"
  //             )
  //           ) {
  //             if (t.FileExtension != "Folder") {
  //               btn += `<a id="${t.Path}" style="cursor:pointer" FileName="${t.FileName}"  class="btnDownload m-portlet__nav-link dropdown-item" title="Download"> 
  //                                       <i class="la la-download"></i> Download
  //                                       </a>`;
  //             } else {
  //               btn += `<a id="${t.Path}" style="cursor:pointer" FileName="${t.FileName}"  class="btnFolderDownload dropdown-item" title="Download"> 
  //                                       <i class="la la-download"></i> Download
  //                                       </a>`;
  //             }
  //           }
  //           if (
  //             SendingMailComponent.that.commonService.CheckHasRight(
  //               "DELETE",
  //               "ATTACHMENT_DETAILS"
  //             )
  //           ) {
  //             btn += `<a Id="${t.Id}" style="cursor:pointer" class="btnDelete dropdown-item" title="Delete">
  //                                   <i class="la la-trash"></i> Delete
  //                                   </a>`;
  //           }

  //           btn += `</div>
  //                      </span>`;
  //           return btn;
  //         },
  //       },
  //     ],
  //   });
  // }

  // DownloadSelectedFile() {
  //   var rows = this.datatable;
  //   rows.rows(".m-datatable__row--active");
  //   if (rows.nodes().length > 0) {
  //     Helpers.setLoading(true);
  //     var selectedListArray: any = [];
  //     $.each(rows.nodes(), function (i) {
  //       var keys = Object.keys(rows.nodes()[i]);
  //       var selectedListOBJ: any = {};
  //       selectedListOBJ = rows.nodes()[i][keys[0]].obj;
  //       selectedListArray.push(selectedListOBJ);
  //     });
  //     console.log('selectedListArray', selectedListArray);
  //     var isValidate: any = true;
  //     var selectedFilePathListArray: any = [];
  //     selectedListArray.forEach(element => {
  //       var obj: any = {};
  //       obj.Id = element.Id;
  //       obj.FilePath = element.Path + element.FileName + "." + element.FileExtension;
  //       obj.FileExtension = element.FileExtension;
  //       selectedFilePathListArray.push(obj);
  //     });
  //     this._appService.Post("Document", "dc_DownloadSelectedFile", selectedFilePathListArray).subscribe((response) => {
  //       Helpers.setLoading(false);
  //       this.DownloadFile(response);
  //     },
  //       (err) => {
  //         Helpers.setLoading(false);
  //         this.toastr.error(err._body.replace(/"/g, ""), "Error");
  //       }
  //     );
  //   } else {
  //     this.toastr.error("Please select any PDF file", "Alert");
  //   }
  // }

  // DownloadFile(FileContent) {
  //   var byteNumbers = new Array(FileContent.Content.length);
  //   for (var i = 0; i < FileContent.Content.length; i++) {
  //     byteNumbers[i] = FileContent.Content.charCodeAt(i);
  //   }
  //   var blob = this.commonService.b64toBlob(
  //     FileContent.Content,
  //     FileContent.ContentType
  //   );
  //   let url = window.URL.createObjectURL(blob);
  //   $("#DownLoadFileSalesReport").attr("href", url);
  //   $("#DownLoadFileSalesReport").attr("download", FileContent.FileName);
  //   let element: HTMLElement = document.getElementById(
  //     "DownLoadFileSalesReport"
  //   ) as HTMLElement;
  //   element.attributes;
  //   element.click();
  // }

  // OnCloseModal() {
  //   $("#UploadInstructions123").modal("hide");
  // }

  // OnShowModal() {
  //   $(".UploadInstructions123").modal("show");
  // }

  // showAttachment(content: any, size: any) {
  //   this.modalReference = this.modalService.open(content, { size: size });

  //   setTimeout(() => {
  //     this.OnAttachmentClick();
  //   }, 1000);
  // }

  // OnAttachmentClick() {

  //   $("#DocumentFrom").val("SalesInvoice");

  //   var obj: any = [];
  //   obj.push(this.InvoiceId);
  //   this.InvoiceDetails.forEach(element => {
  //     obj.push(element.ConsignmentNoteDetailId);
  //   });

  //   SendingMailComponent.that.DocumentType = "SalesInvoice";
  //   SendingMailComponent.that.DocumentTransaction = obj.join(' ,');
  //   SendingMailComponent.that.IsSearchHidden = true;
  //   SendingMailComponent.that.InvoiceIds = this.InvoiceId;

  //   if (this.datatable) {
  //     this.datatable.destroy();
  //     this.GetDocumentsList();
  //     this.datatable.search(
  //       this.DocumentTransaction,
  //       "ReferenceId"
  //     );
  //   }
  // }

  // onClose() {
  //   this.modalReference.close();
  // }

  // AttchFiles() {
  //   this.SelectedAttachements = [];
  //   var rows = this.datatable;
  //   rows.rows(".m-datatable__row--active");
  //   if (rows.nodes().length > 0) {
  //     $.each(rows.nodes(), function (i) {
  //       var keys = Object.keys(rows.nodes()[i]);
  //       var FileList: any = {};
  //       FileList = rows.nodes()[i][keys[0]].obj;
  //       FileList.FileName = FileList.FileName.split(/_(.+)/)[1];
  //       FileList.hrefUrl = environment.apiUrl + FileList.Path + FileList.FileName + "." + FileList.FileExtension;
  //       SendingMailComponent.that.SelectedAttachements.push(FileList);

  //       setTimeout(() => {
  //         console.log(SendingMailComponent.that.SelectedAttachements);
  //         SendingMailComponent.that.modalReference.close();
  //       }, 1000);

  //     });
  //   } else {
  //     this.toastr.error("Please select files to attach!", "error");
  //   }
  // }

  // removefiles(i: any) {
  //   this.SelectedAttachements = this.SelectedAttachements.filter(x => x.Id != i);
  // }
  //added by rahul
  PrintFormatTypes: any = [];

  GetSalesInvoicePrintFormats() {
    this._appService.Get('Sales', 'GetSalesInvoicePrintFormats').subscribe(
      (response) => {
        console.log(response);
        this.PrintFormatTypes = response;
        console.log(this.PrintFormatTypes, 'PrintFormatTypes')
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }
  //end
}
